import { RegisterForm } from "@/components/form/RegisterForm";

const RegisterPage = () => {
  return <RegisterForm />;
};

export default RegisterPage;
